import { createContext } from 'react';

export const FormEditorHeaderSlotContext = createContext(null);
